module.exports = __webpack_public_path__ + "img/techPractice.5590621f.svg";